import { ColumnsType } from "antd/es/table";
import React, { useState } from "react";
import { CONSTANT } from "../../../../config/Constant";
import { PaginationProps } from "antd/lib/pagination";
import { Button, Pagination, Space, Table, Tag, Tooltip } from "antd";
import { camelCaseString } from "../../../../config/Global";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import DeleteWebhook from "./DeleteWebhook";

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    savePayload,
    tableloading,
    setListData,
    setTableLoading,
    setPaginationData,
    getList,
    paginationData,
    totalData,
    openViewDrawer,
  } = props;
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();
  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(true);
    setOpenDeleteData(record);
  };
  const handleDeleteRequestClose = () => {
    setOpenDeleteModal(false);
  };

  const columns: ColumnsType<any> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 20,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.id?.toString().localeCompare(b?.id),
    },
    {
      title: "Requested ID",
      dataIndex: "request_id",
      key: "request_id",
      width: 80,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.request_id?.toString().localeCompare(b?.request_id),
      render: (_, record) => {
        return record?.request_id ? record?.request_id : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Number",
      dataIndex: "random_number",
      key: "random_number",
      width: 80,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.random_number?.toString().localeCompare(b?.random_number),
      render: (_, record) => {
        return record?.random_number
          ? record?.random_number
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Reported App",
      dataIndex: "reported_app",
      key: "reported_app",
      width: 80,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.reported_app?.toString().localeCompare(b?.reported_app),
      render: (_, record) => {
        return record?.reported_app
          ? CONSTANT.REPORTEDAPP_LIST[record?.reported_app]
            ? CONSTANT.REPORTEDAPP_LIST[record?.reported_app]
            : "OTHER"
          : CONSTANT.NO_DATA_FOUND;
      },
    },

    {
      title: "Response",
      dataIndex: "response",
      key: "response",
      width: 40,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.response?.toString().localeCompare(b?.response),
      render: (_, record) => {
        return record?.response ? (
          record?.response === "error" ? (
            <Tag icon={<CloseCircleOutlined />} bordered={false} color="red">
              {camelCaseString(record?.response)}
            </Tag>
          ) : (
            <Tag icon={<CheckCircleOutlined />} bordered={false} color="green">
              {camelCaseString(record?.response)}
            </Tag>
          )
        ) : (
          CONSTANT.NO_DATA_FOUND
        );
      },
    },
    {
      title: "Create At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 80,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.createdAt?.toString().localeCompare(b?.createdAt),
      render: (_, record) => {
        return record?.createdAt
          ? `${record?.createdAt} H`
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 80,
      fixed: "right",
      render: (_, record) => {
        return (
          <Space size="middle">
            <Tooltip title={"View Webhook"}>
              <Button
                type="default"
                icon={<EyeOutlined />}
                className="EditBtn iconBtn"
                onClick={() => openViewDrawer(record)}
              />
            </Tooltip>
            <Tooltip title={"Delete"}>
              <Button
                onClick={() => {
                  handleDeleteRequest(record);
                }}
                icon={<DeleteOutlined />}
                type="default"
                className="cancelBtn iconBtn"
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      page_number: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      page_number: current,
      page_size: page_size,
    };
    getList(updateData);
  };
  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      page_number: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      page_number: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={listData}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={"fixed"}
        />
        <div className="text-center mt-20 mb-30 providerTable">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.page_number}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size ?? 10}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>
      <DeleteWebhook
        open={openDeleteModal}
        deleteValues={openDeleteData}
        title={openDeleteData?.random_number}
        close={handleDeleteRequestClose}
        name={"Number"}
        getList={getList}
      />
    </>
  );
};
export default ListTable;
